import {
  Avatar,
  Box,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useContext } from "react";
import CreateRoundedIcon from "@mui/icons-material/CreateRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import {useTheme } from "@mui/material/styles";
import { GRAY_LIGHT, PRIMARY_COLOR_MediumRoyalBlue } from "../../../constants/Colors";
import draftToHtml from "draftjs-to-html";
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";
import { ProjectContext } from "../../../contexts/ProjectContext";
import ProjectModal from "./ProjectModal";
import { getAPIEndpointUrl } from "../../../utils/ServerRequestModifier";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import ConfirmationDialog from "../../../general_components/ConformationDialog";
import MoveProjectModal from "./MoveProjectModal";

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    position: "absolute",
    top: 0,
    right: 0,
    zIndex: 1,
  },
}));

export default function ProjectCard({ project, categoryName, categoryId }) {
  const classes = useStyles();
  const theme = useTheme();
  const [show, setShow] = React.useState(-1);
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);

  const {
    handleDeleteProject,handleEditProject,projectGallaryImages, setProjectGallaryImages, projectGallaryRawImages,
    setprojectGallaryRawImages, isNewsFile, setIsNewsFile, companyName, setCompanyName, projectLoaction,
    setProjectLoaction, projectTypology, setProjectTypology, projectDescription, setProjectDescription,
    projectArea, setProjectArea, projectStatus, setProjectStatus, projectDate, setProjectDate,
    subCategoryList, fullRawImage, setFullRawImage, cardImage, handleMoveProject,
    setCardImage,
    cardRawImage,
    setCardRawImage,
    projectSubCategory,
    setProjectSubCategory,
    fullImage,
    setFullImage,
    handleEmpty,
    handleFillData,
    editMode,
    setEditMode,
    id,
    setId,
    setOpenDel,
    openDel,
    load,
    categoryList,
    projectCategory,
    setCurrentCategory,
    setPreviousCategory,
    currentCategory,
    previousCategory,
    setCategoryId,
  } = useContext(ProjectContext);

  React.useEffect(() => {
    try {
      document.getElementById(project.newsId).innerHTML = draftToHtml(
        JSON.parse(project.description)
      );
    } catch (e) {}
  }, [project]);

  const handleOpen = (type, project) => {
    if (type === "edit") {
      handleFillData(project);
    }
    setOpen(true);
  };

  const handleClose = () => {
    handleEmpty();
    setOpen(false);
  };
  const handleClose1 = () => {
    setOpen1(false);
  };

  return (
    <>
      <Box
        sx={{
          width: 240,
          height: 350,
          position: "relative",
        }}
        onMouseOver={() => setShow(project.id)}
        onMouseLeave={() => setShow(-1)}
      >
        <div>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div className={classes.buttonContainer}>
              {!(show === project.id) ? null : (
                <>
                  <Tooltip title="Move Project">
                    <IconButton
                      onClick={() => {
                        setOpen1(true);
                        setPreviousCategory({
                          categoryName: categoryName,
                          categoryId: categoryId,
                        });
                      }}
                    >
                      <MoveUpIcon
                        sx={{
                          fontSize: 20,
                          color: GRAY_LIGHT,
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton
                      onClick={() => {
                        setOpenDel(true);
                        setId(project.projectId);
                        setCategoryId(categoryId);
                      }}
                    >
                      <DeleteRoundedIcon
                        sx={{
                          fontSize: 20,
                          color: GRAY_LIGHT,
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Edit">
                    <IconButton
                      onClick={() => {
                        // setProjectCategory(categoryName);
                        handleOpen("edit", project);
                        setEditMode(true);
                      }}
                    >
                      <CreateRoundedIcon
                        sx={{
                          fontSize: 20,
                          color: GRAY_LIGHT,
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                </>
              )}
            </div>
            <Avatar
              sx={{
                width: "100%",
                height: 300,
                borderRadius: "0px",
                zIndex: 0,
              }}
              src={getAPIEndpointUrl() + project.cardImage}
            />
          </Box>
          <Link
            style={{ textDecoration: "none" }}
            to={`/projects/${project.projectId}`}
          >
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              marginTop={1}
            >
              <Typography
                variant="body1"
                color={PRIMARY_COLOR_MediumRoyalBlue}
                sx={{ fontWeight: 700 }}
              >
                {project.title}
              </Typography>
              <Stack>
                <Typography
                  textAlign={"end"}
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontWeight: 600 }}
                >
                  {project.subCategory}
                </Typography>
              </Stack>
            </Box>
          </Link>
        </div>
      </Box>
      <ProjectModal
        title="Edit Project"
        text="Update Project"
        open={open}
        id={project.projectId}
        oldProjectData={project}
        handleClose={handleClose}
        handlerFunction={handleEditProject}
        projectGallaryImages={projectGallaryImages}
        setProjectGallaryImages={setProjectGallaryImages}
        projectGallaryRawImages={projectGallaryRawImages}
        setprojectGallaryRawImages={setprojectGallaryRawImages}
        isNewsFile={isNewsFile}
        setIsNewsFile={setIsNewsFile}
        companyName={companyName}
        setCompanyName={setCompanyName}
        projectLoaction={projectLoaction}
        setProjectLoaction={setProjectLoaction}
        projectTypology={projectTypology}
        setProjectTypology={setProjectTypology}
        projectDescription={projectDescription}
        setProjectDescription={setProjectDescription}
        projectArea={projectArea}
        setProjectArea={setProjectArea}
        projectStatus={projectStatus}
        setProjectStatus={setProjectStatus}
        projectDate={projectDate}
        setProjectDate={setProjectDate}
        subCategoryList={subCategoryList}
        fullRawImage={fullRawImage}
        setFullRawImage={setFullRawImage}
        cardImage={cardImage}
        setCardImage={setCardImage}
        cardRawImage={cardRawImage}
        setCardRawImage={setCardRawImage}
        fullImage={fullImage}
        setFullImage={setFullImage}
        setProjectSubCategory={setProjectSubCategory}
        projectSubCategory={projectSubCategory}
        editMode={editMode}
      />
      <MoveProjectModal
        open={open1}
        setOpen={setOpen1}
        categoryName={categoryName}
        handleClose={handleClose1}
        categoryList={categoryList}
        setCurrentCategory={setCurrentCategory}
        projectId={project.projectId}
        currentCategory={currentCategory}
        previousCategory={previousCategory}
        handleMoveProject={handleMoveProject}
      />
      <ConfirmationDialog
        loading={load}
        open={openDel}
        close={setOpenDel}
        confirm={handleDeleteProject}
        title="Confirmation"
        message="Are you sure you want to delete this?"
        cancelBtnText="Cancel"
        confirmBtnText="Delete"
        setCategoryId={setCategoryId}
        pageName="project"
      />
    </>
  );
}
